<template>
  <tab-container>
    <div slot="operation">
      <a-range-picker
        style="width: 380px"
        :show-time="{
          defaultValue: [
            $moment('00:00:00', 'HH:mm:ss'),
            $moment('23:59:59', 'HH:mm:ss'),
          ],
        }"
        format="YYYY-MM-DD"
        @ok="onChangeTimeRange"
        @change="initData"
      />
    </div>
    <a-table
      :columns="columns"
      :data-source="tableData"
      :pagination="pagination"
      :row-key="record => record.pkId"
      :loading="loading"
      @change="handlePagination"
    />
  </tab-container>
</template>

<script>
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import TabContainer from '@/views/green-construction/components/tab-container.vue';
import { deviceTypeEnum } from '@/enum/device';
import RecordTable from '@/views/green-construction/components/mixins/record-table';
import { deviceRecordList } from '@/services/device-manage/device-detail';

@Component({
  components: {
    TabContainer,
  },
})
export default class SprayLog extends mixins(RecordTable) {
  get columns() {
    return [
      {
        dataIndex: 'index',
        customRender: (text, row, index) => (
          <span>{(this.pagination.current - 1) * 10 + index + 1}</span>
        ),
        title: this.$t('safety.index'),
        align: 'center',
        width: 80,
      },
      {
        align: 'left',
        title: this.$t('greenConstruction.sprayStartTime'),
        dataIndex: 'sprayStartTime',
        ellipsis: true,
        customRender: txt =>
          txt ? this.dayjs(txt).format('YYYY-MM-DD HH:mm:ss') : '',
      },
      {
        align: 'left',
        title: this.$t('greenConstruction.sprayEndTime'),
        dataIndex: 'sprayEndTime',
        ellipsis: true,
        customRender: txt =>
          txt ? this.dayjs(txt).format('YYYY-MM-DD HH:mm:ss') : '',
      },
      {
        align: 'left',
        title: `${this.$t('greenConstruction.sprayDuration')}(${this.$t(
          'greenConstruction.minutes',
        )})`,
        dataIndex: 'sprayMinute',
        ellipsis: true,
        customRender: text => (text >= 0 ? text : ''),
      },
    ];
  }
  getRecordList(queryParams, deviceGroup) {
    return deviceRecordList(queryParams, deviceGroup);
  }
  deviceGroup = deviceTypeEnum.SP.deviceGroup;
}
</script>

<style lang="less" module></style>
